let quizKitFullResults, 
    quizKitRecipientFirstName, 
    quizKitRecipientSurname, 
    quizKitRecipientEmail, 
    quizKitMessage, 
    quizKitSenderName, 
    quizKitDate,
    quizKitAnswers,
    quizID,
    productID,
    quantity;

document.addEventListener('quizKitResultsPageLoaded', function (e) {
  
    quizKitFullResults = e.detail;
    
    // Helper function to find an answer by questionId
    function findAnswerByQuestionId(answers, questionId) {
        return answers.find(answer => answer.questionId === questionId)?.selectedAnswers?.[0]?.value || null;
    }
    
    // Helper function to find an answer by questionId and questionTitle (optional for duplicates)
    function findAnswerByQuestionIdAndTitle(answers, questionId, questionTitle) {
        return answers
            .find(answer => answer.questionId === questionId && answer.questionTitle === questionTitle)
            ?.selectedAnswers?.[0]?.value || null;
    }
    
    // Extracting quiz values
    quizKitRecipientFirstName = findAnswerByQuestionIdAndTitle(e.detail.answers, 142719, "Recipient first name"); // Recipient first name
    quizKitRecipientSurname = findAnswerByQuestionIdAndTitle(e.detail.answers, 142719, "Recipient surname");     // Recipient surname
    quizKitRecipientEmail = findAnswerByQuestionIdAndTitle(e.detail.answers, 142719, "Recipient email");         // Recipient email
    quizKitMessage = findAnswerByQuestionId(e.detail.answers, 142723);                                           // Gift message
    quizKitDate = findAnswerByQuestionId(e.detail.answers, 143179);                                              // Notification date
    
    quizKitSenderName = e.detail.userData.firstName;                                                             // Sender name
    quizKitAnswers = e.detail.answers;                                                                           // All answers
    quizID = e.detail.result.quizId;                                                                             // Quiz ID
    productID = e.detail.result.productIds?.[Object.keys(e.detail.result.productIds)?.[0]]?.[0] ?? null;         // Product ID
    quantity = 1;      

}, false);

document.addEventListener('quizKitAddToCart', function (e) { 
   
  fetch('/cart/add.js', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'id': productID.toString(),
        'properties': { 
          '_quiz_kit_answers': quizKitAnswers,
          '_quiz_kit_id': quizID,
          '__rc_gift_recipient_first_name': quizKitRecipientFirstName,
          '__rc_gift_recipient_last_name': quizKitRecipientSurname,
          '__rc_gift_recipient_email': quizKitRecipientEmail,
          '__rc_gift_recipient_note': quizKitMessage,
          '__rc_gift_sender_name': quizKitSenderName,
          '__rc_gift_notification_scheduled_at': quizKitDate
        }
      })
  })
  .then(response => response.json()).then(data => {
      console.log(data);
  })
  .catch(error => {
      console.error('Error:', error);
  });
  

}, false);
